var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bd3d44",
    d: "M0 0h640v37.9H0zm0 75.8h640v37.9H0zm0 75.8h640v37.9H0zm0 75.8h640v37.9H0zm0 75.8h640v37.9H0zm0 75.8h640V480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 37.9h640v37.9H0zm0 75.8h640v37.9H0zm0 75.8h640v37.9H0zm0 75.8h640v37.9H0zm0 75.8h640v37.9H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#192f5d",
    d: "M0 0h256v258.5H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 37,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 37,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 37,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 37,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 74,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 74,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 74,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 74,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 111,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 111,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 111,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 111,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 148,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 148,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 148,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 148,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 185,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 185,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 185,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 185,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 222,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 222,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 222,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 222,
    r: 12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.f3e999de1b0dd58b73e98509a2e2e388.svg";
export { ForwardRef as ReactComponent };